import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import ModulePage from "./pages/ModulePage";
import LessonPage from "./pages/LessonPage";
import BadgesPage from "./pages/BadgesPage";
import CertificatePage from "./pages/CertificatePage";
import QuizPage from "./pages/QuizPage";
import GlossaryPage from "./pages/GlossaryPage";
import StatsPage from "./pages/StatsPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/module/:moduleId" element={<ModulePage />} />
        <Route path="/lesson/:lessonId" element={<LessonPage />} />
        <Route path="/badges" element={<BadgesPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/certificate" element={<CertificatePage />} />
        <Route path="/glossary" element={<GlossaryPage />} />
        <Route path="/stats" element={<StatsPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;